/* eslint no-eval: 0 */
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import dJSON from 'dirty-json';

const CovidQuestionnaires = ({ registrationInfo }) => {
  const [filterData, setFilterData] = useState({});

  const questionnaires = _.get(registrationInfo, 'attributes.question_and_answers');

  const filterCovidQAList = (data, value) => {
    if (!data) return false;

    if (!data.indexOf('title')) return []

    return data.filter((x) => x.title === value);
  };

  useEffect(() => {
    setFilterData(() => ({
      ...filterData,
      medicalRecord: registrationInfo ? filterCovidQAList(dJSON.parse(questionnaires), 'MEDICAL HISTORY') : [],
      nonMedicalRecord: registrationInfo ? filterCovidQAList(dJSON.parse(questionnaires), '') : [],
    }));
  }, []);

  return _.isEmpty(registrationInfo) ? (
    <div className="row d-flex  mb-1 p-3 ml-3">There are no items found.</div>
  ) : (
    <div
      className="row d-flex mb-1 p-3"
      style={{ minHeight: '400px', overflowY: 'scroll' }}
    >
      <div className="col-12 pb-2">
        {!filterData.medicalRecord ? (
          <div>Invalid Data supplied</div>
        ) : (
          <>
            {filterData.nonMedicalRecord.map((item) => (
              <div key={item.question} className="my-2 cit-inner">
                <label className="font-weight-bold mb-0 mr-2 prof-label">
                  {item.question}
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">{item.answer}</span>
              </div>
            ))}
            <hr />
            <label>MEDICAL HISTORY</label>
            {filterData.medicalRecord.map((item) => (
              <div key={item.question} className="my-2 cit-inner">
                <label className="font-weight-bold mb-0 mr-2 prof-label">
                  {item.question}
                </label>
                <span className="cit-span">:</span>
                <span className="transaction-text p-0">{item.answer}</span>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

CovidQuestionnaires.propTypes = {
  registrationInfo: PropTypes.instanceOf(Object).isRequired,
};

export default CovidQuestionnaires;
